import { styled } from "styled-components";

export const BottomMargin = styled.div`
  margin-bottom: 50px;
`;
